import { IDeleteControleEnergiaUseCase } from "../../../presentation/useCases/delete/delete_controle_energia_use_case";
import { DeleteControleEnergiaRequestModel, DeleteControleEnergiaResponseModel } from "../../models/obras_sustentabilidade_model";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteControleEnergiaUseCase
 */

export class DeleteControleEnergiaUseCase implements IDeleteControleEnergiaUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async deleteControleEnergia(model: DeleteControleEnergiaRequestModel): Promise<DeleteControleEnergiaResponseModel> {
    return await this.repository.deleteControleEnergia(model);
  }
}
